import { convertCard } from '../reducers/handReducer';
//
export const throwCard = (suite, value, position) => {
	// convert card
	const type = {
		0: 'heart', // ,
		1: 'nut', // ,
		2: 'leave', // ,
		3: 'bell', // ,
	};
	const card = {
		2: 'jack', // ,
		3: 'queen', // ,
		4: 'king', // ,
		6: 'septar', // ,
		8: 'optar', // ,
		9: 'nine', // ,
		10: 'ten', // ,
		11: 'ace', // ,
	};
	//
	const convertedCard = { suit: type[suite], card: card[value] };

	//
	return {
		type: 'THROW_CARD',
		// id,
		show: true,
		position,
		...convertedCard,
	};
};

export const enableHand = (value) => ({
	type: 'ENABLE_HAND',
	value,
});

export const disableHand = (value) => ({
	type: 'DISABLE_HAND',
	value,
});

export const resetHand = () => ({
	type: 'RESET_HAND',
});

export const setCards = (cards, extend) => ({
	type: 'SET_CARDS',
	cards: cards,
	extend: extend,
});

export const setCurrentPlayer = (currentPlayerIndex) => ({
	type: 'SET_CURRENT_PLAYER',
	currentPlayerIndex: currentPlayerIndex,
});
